import {
  makeKey,
  update,
  handleApiResponseError,
  handleNetworkError,
} from "../../../../utils/reducerOperations";
import { toast } from "../../../../utils/messageUtils";

export function changeFirstLastNameFailed(state, payload) {
  let response = makeKey(
    "changeFirstLastNameApi",
    update(
      state.changeFirstLastNameApi,
      payload.response && payload.response.data
        ? handleApiResponseError(payload.response.data)
        : handleNetworkError(payload)
    )
  );
  toast.error(response.changeFirstLastNameApi.reason);
  return response;
}
